import React from 'react';
import { Skeleton } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const Scenario = ({ loading, scenario }) => {
  if (loading) {
    return (
      <>
        <Skeleton className="mb-4" />
        <Skeleton className="mb-16" />
      </>
    );
  }

  return (
    <>
      <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
        {t('practice.role_play.titles.scenario')}
      </Text>
      <Text className="mb-16 minh-30" variant={TEXT_VARIANTS.BODY}>
        {scenario}
      </Text>
    </>
  );
};

export default Scenario;
